import { MaterialModule } from './material.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AddParentsComponent } from '../components/add-parents/add-parents.component';
import { AddClassComponent } from '../components/add-class/add-class.component';
import { AddEventComponent } from '../components/add-event/add-event.component';
import { AddNotificationComponent } from '../components/add-notification/add-notification.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    NgxDatatableModule, 
    MaterialModule,
  ],
  declarations: [
    AddParentsComponent,
    AddClassComponent,
    AddEventComponent,
    AddNotificationComponent

  ],
  exports: [
    ReactiveFormsModule,
    NgxDatatableModule,
    MaterialModule,
    AddParentsComponent,
    AddClassComponent,
    AddNotificationComponent,
    AddEventComponent
  ],
})
export class SharedModule {}
